const ErrorFallback = () => (
  <div className="vh-100 d-flex flex-column align-items-center justify-content-center">
    <div
      style={{ fontSize: '64px' }}
      className="text-danger k-icon k-i-error"
    />
    <h3 className="text-danger mb-3">Something went wrong</h3>
    <p className="mb-2">
      There was a problem in loading this page. Please try again by refreshing
      the page.
    </p>
    <p>
      To report an issue, please contact the <b>b2c-admin</b> team
    </p>
  </div>
);

export default ErrorFallback;
